export function createEspWebToolsAdapter({ target = window } = {}) {
  return {
    flash() {
      return new Promise((resolve, reject) => {
        const onSuccess = () => { cleanup(); resolve(); };
        const onError = (e) => { cleanup(); reject(new Error((e.detail && e.detail.error) || 'Firmware installation failed')); };
        function cleanup() {
          target.removeEventListener('esp-web-install-success', onSuccess);
          target.removeEventListener('esp-web-install-error', onError);
        }
        target.addEventListener('esp-web-install-success', onSuccess);
        target.addEventListener('esp-web-install-error', onError);
      });
    },
  };
}
